<template>
  <div>
    <div class="change-password">
      <form action="">
        <div class="tel">
          <span class="title">手机号</span>
          <div class="tel-content">
            <div class="area-num">
              <span class="area-num-icon">+</span>
              <el-select v-model="changePassword.area" placeholder="请选择">
                <el-option v-for="item in areaCodeList" :key="item.numcode" :label="item.phonecode" :value="item.phonecode">
                  <span style="float: left">{{ item.nameZh }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.phonecode }}</span>
                </el-option>
              </el-select>
            </div>
            <input type="text" placeholder="请输入您的手机号" v-model="changePassword.phone" autocomplete="off"/>
          </div>
        </div>
        <div class="check-code">
          <span class="title">验证码</span>
          <div class="check-code-content">
            <input placeholder="请输入验证码" v-model="changePassword.code" autocomplete="off" />
            <button class="get-check-code" @click="sendMsg(changePassword.area, changePassword.phone)" v-if="phone_text === '获取验证码'">
              {{ phone_text }}
            </button>
            <button class="get-check-code unactive" v-else>
              {{ phone_text }}
            </button>
          </div>
        </div>
        <div class="new-password">
          <span class="title">新密码</span>
          <div class="new-password-content">
            <input type="password" placeholder="请输入新密码" v-model="changePassword.newPassword" autocomplete="off"/>
          </div>
        </div>
        <div class="save-btn">
          <button class="save-info" @click="handleChangePassword">保存</button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import sendMessage from '../../mixins/sendMessage'
export default {
  data() {
    return {
      changePassword: {
        phone: '',
        area: '86',
        code: null,
        newPassword: null
      },
      phone_text: '获取验证码'
    }
  },
  created(){
     console.log('[<-- this.changePassword.code -->]',this.changePassword.code);
     
  },
  props: ['areaCodeList'],
  mixins: [sendMessage],
  methods: {
    // 修改密码
    handleChangePassword() {
      const data = {
        phone: this.changePassword.phone,
        password: this.changePassword.newPassword,
        code: this.changePassword.code,
        area: this.changePassword.area,
        org_id: this.org_id
      }
      this.$axios
        .post('/user/index/updatePwd', data)
        .then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: '修改成功!',
              type: 'success'
            })
            this.changePassword.phone = ''
            this.changePassword.code = ''
            this.changePassword.newPassword = ''
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        })
        .catch(res => {
          this.$message({
            message: res.data.message,
            type: 'error'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
input:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
}
/* 修改密码样式 */
.change-password {
  padding: 0 228px;
}
.change-password .title {
  font-size: 14px;
  color: #808695;
  width: 56px;
  margin-right: 24px;
}

.change-password input {
  width: 70%;
  border: none;
  outline: none;
  background-color: transparent;
}
.check-code,
.new-password {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.tel {
  position: relative;
}
.check-code-content,
.new-password-content {
  width: 404px;
  height: 44px;
  border: #e8eaec 1px solid;
  border-radius: 2px;
  box-sizing: border-box;
  padding-left: 16px;
  font-size: 14px;
  line-height: 44px;
}
.change-password .tel-content {
  position: relative;
  padding-left: 91px;
}
.change-password .area-num {
  position: absolute;
  left: 0;
  width: 75px;
  text-align: center;
  color: #808695;
}
.change-password .area-num::after {
  width: 1px;
  height: 20px;
  content: '';
  display: block;
  background: #e8eaec;
  position: absolute;
  right: 0;
  top: 10px;
}
.area-num .area-num-icon {
  z-index: 99;
  position: absolute;
  left: 11px;
}
.area-num {
  ::v-deep .el-select {
    position: absolute;
    left: 25px;
    top: 0;
  }
}

.area-num {
  ::v-deep .el-input__inner {
    border: none;
    height: 20px;
    padding: 0;
  }
}
.area-num {
  ::v-deep .el-select__caret {
    color: #1872ed !important;
  }
}
.check-code {
  position: relative;
}
.get-check-code {
  position: absolute;
  right: 0;
  height: 100%;
  padding: 0 20px;
  background: transparent;
  border: none;
  border-left: #e8eaec 1px solid;
  color: #1872ed;
  cursor: pointer;
}
.unactive {
  color: #737373;
}
.save-btn {
  margin-top: 30px !important;
  width: 200px;
  height: 40px;
  text-align: center;
  margin: 0 auto;
  color: #ffffff;
}
.save-btn button {
  width: 100%;
  height: 100%;
  border: none;
  background: linear-gradient(135deg, #73aaff 5%, #0053ff 95%);
  line-height: 40px;
  font-size: 16px;
  border-radius: 20px;
  color: #ffffff;
  cursor: pointer;
}
.tel {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.tel-content {
  width: 404px;
  height: 44px;
  border: #e8eaec 1px solid;
  border-radius: 2px;
  box-sizing: border-box;
  padding-left: 16px;
  font-size: 14px;
  line-height: 44px;
}
.change-tel-bind {
  position: absolute;
  color: #10a675;
  width: 88px;
  right: 0;
  text-align: center;
  border-left: 1px #e8eaec solid;
  cursor: pointer;
}
/deep/ .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
background: #e1edff !important;
}
</style>
